@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.pointsOfInterest

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.pointsOfIntrest.PointOfInterestDto


object GetAreaPointsOfInterestForPassengerEndpoint :
    EndPoint<GetAreaPointsOfInterestForPassengerEndpoint.Request, GetAreaPointsOfInterestForPassengerEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String,
        val startLat: Double,
        val startLng: Double,
        val endLat: Double,
        val endLng: Double,
        val lowestPriority: Int?
    )

    class Response(
        val list: Array<PointOfInterestDto>,
    )
}